/*
 * SQL Server Licensing Calculator
 *
 * Logic runs on stable IDs (question IDs and answer IDs), never on display text.
 * Display text comes from window.SQL_CALC_I18N, which is rendered from the theme
 * locale files by snippets/sql-calc-i18n.liquid, so translation apps can translate it.
 *
 * Text that goes to the sales team (Express Quote form results, Calendly prefill)
 * always uses SQL_CALC_EN below, so sales receives English regardless of storefront language.
 */

// English text used for sales-facing output, and as a fallback for display text
var SQL_CALC_EN = {
  questions: {
    environment: 'Is this for an On-Premises or Cloud Environment?',
    version: 'What version year do you need?',
    edition: 'What edition do you need?',
    instances: 'How many SQL instances do you need to license?',
    query_method: 'How is the database queried?',
    public_app: 'Are you running a public web-facing application?',
    connections_direct: 'How many connect directly to SQL?',
    connections_app: 'How many connect to the application?',
    deployment: 'Is your SQL instance deployed on Host or VM?',
    host_cores: 'How many physical cores does your host have?',
    vm_cores: 'How many cores does the VM have allocated?'
  },
  answers: {
    on_prem: 'On-Premises',
    cloud: 'Cloud',
    standard: 'Standard',
    enterprise: 'Enterprise',
    one: 'One',
    two_plus: 'Two or more',
    direct: 'Directly to SQL',
    application: 'Through an application',
    yes: 'Yes',
    no: 'No',
    host: 'Host',
    vm: 'VM'
  },
  requirements: {
    select_users_devices_html: 'Select either <b>Users</b> or <b>Devices</b>',
    total_connections: 'Enter the total amount of connections',
    min_one_connection: 'Minimum of 1 connection required',
    min_cores: 'Minimum of 4 cores',
    even_cores: 'The total must be an even number'
  },
  ui: {
    enter_answer: 'Enter answer here',
    min_required: 'Minimum of [n] required',
    continue: 'Continue',
    users: 'Users',
    devices: 'Devices',
    percent_complete: '[percent] COMPLETE',
    more_than: 'More than [n]',
    users_count: '[n] user(s)',
    devices_count: '[n] device(s)'
  },
  results: {
    model_core: 'Core model',
    model_server_cal: 'Server+CAL model',
    recommend_html: 'To best suit your environment, we highly recommend the [model], which offers significant cost savings. Take the next step by <strong>requesting a personalized quote</strong>. Our team will assess your environment thoroughly to determine if you qualify for additional savings.',
    what_you_need_model: 'Here\'s what you\'ll need to fully license your SQL Server environment through the [model]. ',
    enterprise_required: 'Although you selected Standard, Enterprise edition is required for your environment because Standard can only license a max of 24 cores.',
    both_models: 'For your environment, either licensing model would be suitable. However, if you have plans to expand your business, we highly recommend [link] with one of our licensing experts. Their expertise will help you determine the ideal model that aligns with your growth goals and specific requirements. ',
    both_what_you_need: 'Your choice between the options will determine the specific licensing requirements based on your responses. Here\'s what you\'ll need to license under each option. If you\'re unsure which one to choose, consider [link] with one of our licensing experts for guidance.',
    scheduling_a_call: 'scheduling a call',
    our_recommendation: 'Our recommendation',
    th_recommended_license: 'Recommended License',
    th_num_licenses: '# of Licenses',
    core_disclaimer: 'Standard edition can only license a maximum of 24 cores',
    core_disclaimer_2025: 'SQL Server 2025 standard edition supports up to 32 cores'
  },
  rfq: {
    greeting: 'Hi TrustedTech,',
    request: 'Could you please send me a personalized quote based on my SQL Server Calculator results?',
    thanks: 'Thank you!',
    results_heading: 'My SQL Server Calculator Results:',
    recommended_model: 'Recommended licensing model:',
    both: 'Both',
    core_model: 'Core Model',
    server_cal_model: 'Server+CAL Model',
    server_cal_licensing: 'Server+CAL model licensing:',
    core_licensing: 'Core model licensing:',
    responses: 'Responses:'
  },
  licenses: {
    server: 'Microsoft SQL Server [year] [edition] - License[sa]',
    core: 'Microsoft SQL Server [year] [edition] - 2 Core License[sa]',
    cal: 'Microsoft SQL Server [year] - 1 [type] CAL[sa]',
    sa_suffix: ' (w/ Software Assurance)',
    cal_type_user: 'User',
    cal_type_device: 'Device'
  }
};

// Display text for the current storefront language (falls back to English per key)
var SQL_CALC_I18N = window.SQL_CALC_I18N || {};

function lookup(obj, path) {
  return path.split('.').reduce(function(o, k) { return (o && o[k] !== undefined) ? o[k] : undefined; }, obj);
}

// Replace [placeholders] in a string with values
function fmt(str, vars) {
  if (!vars) { return str; }
  return str.replace(/\[(\w+)\]/g, function(match, key) {
    return Object.prototype.hasOwnProperty.call(vars, key) ? String(vars[key]) : match;
  });
}

// Display text (translated)
function tr(path, vars) {
  var value = lookup(SQL_CALC_I18N, path);
  if (value === undefined || value === null || value === '') { value = lookup(SQL_CALC_EN, path); }
  if (value === undefined || value === null) { value = ''; }
  return fmt(String(value), vars);
}

// Sales-facing text (always English)
function en(path, vars) {
  var value = lookup(SQL_CALC_EN, path);
  return fmt(value === undefined ? '' : String(value), vars);
}

// Display label for an answer ID (version years have no label and show as-is)
function answerLabel(id) {
  return lookup(SQL_CALC_EN, 'answers.' + id) !== undefined ? tr('answers.' + id) : id;
}
function answerLabelEn(id) {
  return lookup(SQL_CALC_EN, 'answers.' + id) !== undefined ? en('answers.' + id) : id;
}
function questionText(id) {
  return lookup(SQL_CALC_EN, 'questions.' + id) !== undefined ? tr('questions.' + id) : id;
}
function questionTextEn(id) {
  return lookup(SQL_CALC_EN, 'questions.' + id) !== undefined ? en('questions.' + id) : id;
}

// Store user's answers to questions (order here is the order shown on the results page)
// answerType: 'option' (button), 'value' (number input) or 'over_max' (input above the maximum)
var userAnswers = [
  { id: 'environment', answer: '' },
  { id: 'version', answer: '' },
  { id: 'edition', answer: '' },
  { id: 'instances', answer: '' },
  { id: 'query_method', answer: '' },
  { id: 'public_app', answer: '' },
  { id: 'connections_direct', customObj: '' },
  { id: 'connections_app', customObj: '' },
  { id: 'deployment', answer: '' },
  { id: 'host_cores', answer: '' },
  { id: 'vm_cores', answer: '' }
];

// Store all calculator questions
var questionTree = [
  {
    id: 'environment',
    answers: ['on_prem', 'cloud'],
    followUpQuestions: { on_prem: 'version', cloud: 'version' },
    percentComplete: '0%'
  },
  {
    id: 'version',
    answers: ['2025', '2022', '2019', '2017', '2016'],
    followUpQuestions: { '2025': 'edition', '2022': 'edition', '2019': 'edition', '2017': 'edition', '2016': 'edition' },
    percentComplete: '12%'
  },
  {
    id: 'edition',
    answers: ['standard', 'enterprise'],
    followUpQuestions: { standard: 'instances', enterprise: 'instances' },
    percentComplete: '24%'
  },
  {
    id: 'instances',
    answers: ['one', 'two_plus'],
    followUpQuestions: { one: 'query_method', two_plus: 'END' },
    customAnswersBasedDependency: {
      onPremStandard: 'query_method',
      onPremEnterprise: 'deployment',
      cloudStandard: 'query_method',
      cloudEnterprise: 'vm_cores'
    },
    percentComplete: '36%'
  },
  {
    id: 'query_method',
    answers: ['direct', 'application'],
    followUpQuestions: { direct: 'connections_direct', application: 'public_app' },
    percentComplete: '42%'
  },
  {
    id: 'public_app',
    answers: ['yes', 'no'],
    followUpQuestions: { yes: 'deployment', no: 'connections_app' },
    percentComplete: '52%'
  },
  {
    id: 'connections_direct',
    answers: ['custom-input-connections-count'],
    followUpQuestions: { 'custom-input-connections-count': 'deployment' },
    minimumBasedDependency: { minimumCount: 25, minimumMet: 'deployment', minimumNotMet: 'END' },
    customAnswersBasedDependency: {
      onPremStandard: 'deployment',
      onPremEnterprise: 'deployment',
      cloudStandard: 'vm_cores',
      cloudEnterprise: 'vm_cores'
    },
    minimumInput: '1',
    maximumInput: '1000',
    inputRequirements: ['select_users_devices_html', 'total_connections', 'min_one_connection'],
    percentComplete: '75%'
  },
  {
    id: 'connections_app',
    answers: ['custom-input-connections-count'],
    followUpQuestions: { 'custom-input-connections-count': 'deployment' },
    minimumBasedDependency: { minimumCount: 25, minimumMet: 'deployment', minimumNotMet: 'END' },
    customAnswersBasedDependency: {
      onPremStandard: 'deployment',
      onPremEnterprise: 'deployment',
      cloudStandard: 'vm_cores',
      cloudEnterprise: 'vm_cores'
    },
    minimumInput: '1',
    maximumInput: '1000',
    inputRequirements: ['select_users_devices_html', 'total_connections', 'min_one_connection'],
    percentComplete: '75%'
  },
  {
    id: 'deployment',
    answers: ['host', 'vm'],
    followUpQuestions: { host: 'host_cores', vm: 'vm_cores' },
    percentComplete: '87%'
  },
  {
    id: 'host_cores',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'END' },
    minimumInput: '4',
    maximumInput: '1000',
    inputRequirements: ['min_cores', 'even_cores'],
    evenInput: 'true',
    percentComplete: '97%'
  },
  {
    id: 'vm_cores',
    answers: ['standard-input'],
    followUpQuestions: { 'standard-input': 'END' },
    minimumInput: '4',
    maximumInput: '1000',
    inputRequirements: ['min_cores', 'even_cores'],
    evenInput: 'true',
    percentComplete: '97%'
  },
  {
    id: 'END',
    answers: [],
    followUpQuestions: {},
    percentComplete: '100%'
  }
];

// The question currently on screen
var currentQuestionId = 'environment';

// Track the user's pathway to navigate backwards if needed
var previousQuestionPath = [];

// Default Calendly link
var CALENDLY_SQL_BASE = 'https://calendly.com/trusted-tech-team-licensing-engineer-uk/sql';
var calendlySqlLink = CALENDLY_SQL_BASE;

// Text sent to the 'Request a Quote' form.
// calcResults is always English (for sales). calcResultsLocal is the same text in the visitor's language.
// On non-English storefronts the form receives the local version followed by the English copy (see rfqForForm).
function rfqIntro(t) {
  return t('rfq.greeting') + '\r\n\r\n' + t('rfq.request') + '\r\n\r\n' + t('rfq.thanks') + '\r\n\r\n' + t('rfq.results_heading') + '\r\n\r\n';
}
var CALC_RESULTS_INTRO = rfqIntro(en);
var calcResults = CALC_RESULTS_INTRO;
var calcResultsLocal = rfqIntro(tr);

// Snapshot of the results page markup so 'Restart' can restore it exactly (already translated by Liquid)
var initialResultsHTML = {
  models: (document.getElementById('licensing-models-container') || {}).innerHTML || '',
  cal: (document.getElementById('cal-licensing-container') || {}).innerHTML || ''
};

function getQuestion(id) {
  return questionTree.find(function(obj) { return obj.id == id; });
}

function getUserAnswer(id) {
  return userAnswers.find(function(obj) { return obj.id == id; });
}

// Show a question's text and answers
function renderQuestion(id) {
  currentQuestionId = id;
  document.getElementById('sql-question-text').innerHTML = questionText(id);
  displayAnswers(getQuestion(id));
}

// Display the answers or table for a question
function displayAnswers(questionObject) {

  // Store the HTML for the possible answers that will be displayed for each question
  var questionInputsHTML = '';
  var minRequiredText = questionObject.minimumInput ? tr('ui.min_required', { n: parseInt(questionObject.minimumInput) }) : '';
  // First question keeps its original button spacing
  var buttonMargin = questionObject.id == 'environment' ? 'm-0' : 'm-auto';

  // Get all the possible answers for the current question and iterate through them all
  questionObject.answers.forEach((answer, index, arr) => {
    if (answer != undefined && answer != 'standard-input' && answer != 'custom-input-connections-count') {
      questionInputsHTML += '<button class="raise collection-button calc-button ' + buttonMargin + ' text-start" onclick="showNextQuestion(\'' + answer + '\', this)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>' + answerLabel(answer) + '</button>';
      if (arr.length - 1 == index) {
        questionInputsHTML = '<div class="d-flex flex-wrap gap-3 justify-content-start justify-content-lg-center">' + questionInputsHTML + '</div>';
      }
    } else if (answer == 'standard-input') {
      questionInputsHTML += '<div class="position-relative text-center"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="' + minRequiredText + '"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.maximumInput ? (' max="' + parseInt(questionObject.maximumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
      questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" data-eveninput="' + (questionObject.evenInput == 'true') + '" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center; margin: 0 0 10px;" placeholder="' + tr('ui.enter_answer') + '" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + minRequiredText + '</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button m-auto text-center" onclick="showNextQuestion(\'' + answer + '\')"';
      questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>' + tr('ui.continue') + ' <i class="fa-solid fa-arrow-right"></i></button>';
    } else if (answer == 'custom-input-connections-count') {
      questionInputsHTML += '<div class="d-flex justify-content-start justify-content-lg-center gap-3" id="toggle-container" style="margin: 0;"><div id="toggle-btn-container" class="d-flex justify-content-between"><button class="collection-button calc-button m-0 me-3 selected" id="users-button" style="padding: 1em 1.4em; border: 2px solid var(--main-text-color); width: 49%; text-align: start;" onclick="toggle(&#39;users&#39;)"><i class="fa-regular fa-circle regular" style="display: none;"></i><i class="fa-solid fa-circle solid" style="display: inline;"></i>' + tr('ui.users') + '</button><button class="collection-button calc-button m-0" id="devices-button" style="padding: 1em 1.4em; border: 2px solid var(--main-text-color); width: 49%; text-align: start;" onclick="toggle(&#39;devices&#39;)"><i class="fa-regular fa-circle regular"></i><i class="fa-solid fa-circle solid" style="display: none;"></i>' + tr('ui.devices') + '</button></div></div>';
      questionInputsHTML += '<div class="position-relative text-center my-3"><i class="fa-solid fa-circle-exclamation" ' + (questionObject.minimumInput && ('data-tippy-content="' + minRequiredText + '"')) + ' style="display: none; position: absolute; right: 20px; top: 38%; color: red;"></i><i class="fa-solid fa-circle-check" style="display: none; position: absolute; right: 20px; top: 38%; color: green;"></i><input id="standard-input"' + (questionObject.minimumInput ? (' min="' + parseInt(questionObject.minimumInput) + '"') : ' ') + (questionObject.maximumInput ? (' max="' + parseInt(questionObject.maximumInput) + '"') : ' ') + (questionObject.emptyInputAccepted ? (' data-emptyinputaccepted="true" ') : ' ');
      questionInputsHTML += 'data-toggle="collapse" data-target="#epSubNew" data-eveninput="' + (questionObject.evenInput == 'true') + '" oninput="validateValue(this.value, this)" type="text" style="transition: none; text-align: center; margin: 0;" placeholder="' + tr('ui.enter_answer') + '" /></div><p style="color: red; display: none;" id="min-input-error"><i class="fa-solid fa-circle-exclamation" style="margin-right: 5px;"></i>' + minRequiredText + '</p><button style="transition: transform 0.25s;" class="raise collection-button calc-button m-auto text-center" onclick="showNextQuestion(\'' + answer + '\')"';
      questionInputsHTML += (parseInt(questionObject.minimumInput) > 0 && 'disabled') + '>' + tr('ui.continue') + ' <i class="fa-solid fa-arrow-right"></i></button>';
    }
  });

  // Display input requirements for the current question if applicable
  if (questionObject.inputRequirements) {
    var inputRequirementsHTML = '<ul class="text-start">';
    questionObject.inputRequirements.forEach((key) => {
      inputRequirementsHTML += '<li>' + tr('requirements.' + key) + '</li>';
    });
    inputRequirementsHTML += '</ul>';
    document.getElementById('input-requirements').innerHTML = inputRequirementsHTML;
  } else {
    document.getElementById('input-requirements').innerHTML = '';
  }

  // Display everything
  document.getElementById('sql-question-answers').innerHTML = questionInputsHTML;
  document.querySelector('.progress-bar').style = "width: " + questionObject.percentComplete + "; background-color: var(--border-color);";
  document.querySelector('#percent-complete').innerHTML = tr('ui.percent_complete', { percent: questionObject.percentComplete });
}

// Toggle for the USER/DEVICE connections count
function toggle(selectedOption) {
  var usersButton = document.getElementById('users-button');
  var devicesButton = document.getElementById('devices-button');

  if (selectedOption === 'users') {
    usersButton.classList.add('selected');
    devicesButton.classList.remove('selected');

    usersButton.querySelector('.regular').style.display = "none";
    usersButton.querySelector('.solid').style.display = "inline";
    devicesButton.querySelector('.regular').style.display = "inline";
    devicesButton.querySelector('.solid').style.display = "none";

  } else if (selectedOption === 'devices') {
    usersButton.classList.remove('selected');
    devicesButton.classList.add('selected');

    usersButton.querySelector('.regular').style.display = "inline";
    usersButton.querySelector('.solid').style.display = "none";
    devicesButton.querySelector('.regular').style.display = "none";
    devicesButton.querySelector('.solid').style.display = "inline";
  }
}

// Toggle the view of 'Your Answers'
function toggleYourAnswers(toggle) {
  if (toggle == 'show') {
    $('#your-answers').height('min-content');
    $('#your-answers-cover').hide();
  } else if (toggle == 'hide') {
    $('#your-answers').height('225px');
    $('#your-answers-cover').show();
  }
}

// Clear a stored answer
function clearAnswer(entry) {
  if ('customObj' in entry) { entry.customObj = ''; }
  entry.answer = '';
  delete entry.answerType;
  delete entry.overMax;
}

// Show the previous question when user navigates backwards
function showPreviousQuestion() {

  // Find the previous question and display it
  var previousId = previousQuestionPath[previousQuestionPath.length - 1];
  var currentQuestionObject = getQuestion(previousId);
  currentQuestionId = previousId;
  document.getElementById('sql-question-text').innerHTML = questionText(previousId);

  // Clear the previous question's stored answer
  var entry = getUserAnswer(previousId);
  if (entry) { clearAnswer(entry); }

  setCalendlyOnClick('help', previousId);

  displayAnswers(currentQuestionObject);
  previousQuestionPath.pop();

  // If first question then hide 'previous' button
  if (previousQuestionPath.length > 0) {
    $('.btn-previous').show();
  } else {
    $('.btn-previous').hide();
  }

  setTooltips();
}

// Validate the inputs on submit
function validateInputs(answer) {
  let noContinue = false;
  if (answer == "standard-input") {
    let minInputError = false;
    let input = document.querySelector('#standard-input');
    if (input.max && ((parseInt(input.value)) > (parseInt(input.max)))) {
      setOverMaxAnswer(input.max);
      showResults("calc-error");
      return false;
    }
    if ((parseInt(input.min) > 0 && parseInt(input.value) < parseInt(input.min)) && (input.dataset.emptyinputaccepted == 'true' ? (parseInt(input.value) != '0' || parseInt(input.value) != '') : true)) {
      input.style.border = '1px solid red';
      input.previousElementSibling.style.display = 'inline';
      minInputError = true;
      noContinue = true;
    } else if (parseInt(input.min) == 0 && input.value == '') {
      input.value = 0;
      input.setAttribute('value', 0);
    }
    minInputError ? $('#min-input-error').show() : $('#min-input-error').hide();
    if (noContinue) { return false; }
  } else if (answer == "custom-input-connections-count") {
    let input = document.querySelector('#standard-input');
    if (input.max && ((parseInt(input.value)) > (parseInt(input.max)))) {
      setOverMaxAnswer(input.max);
      showResults("calc-error");
      return false;
    }
  }
}

// Record that the user entered more than the maximum on the current question
function setOverMaxAnswer(max) {
  var entry = getUserAnswer(currentQuestionId);
  if (!entry) { return; }
  entry.answer = '';
  entry.answerType = 'over_max';
  entry.overMax = max;
}

// Store the user's submitted input
function setAnswer(answer) {
  var entry = getUserAnswer(currentQuestionId);
  if (!entry) { return; }
  if (answer == 'standard-input') {
    entry.answer = document.getElementById('standard-input').value;
    entry.answerType = 'value';
  } else if (answer == 'custom-input-connections-count') {
    var customInputObj = { type: '', total: '' };
    if (document.getElementById('users-button').classList.contains('selected')) {
      customInputObj.type = 'user';
    } else {
      customInputObj.type = 'device';
    }
    customInputObj.total = document.getElementById('standard-input').value;
    entry.customObj = customInputObj;
  } else {
    entry.answer = answer;
    entry.answerType = 'option';
  }
}

// Returns the user's answer (answer ID or entered value) for a question ID
function getAnswer(id) {
  var entry = getUserAnswer(id);
  if (!entry) { return ''; }
  if (entry.customObj && entry.customObj.total) {
    return entry.customObj.total;
  }
  return entry.answer || '';
}

// Returns the stored users/devices object for a connections question, or an empty object
function getConnections(id) {
  var entry = getUserAnswer(id);
  return (entry && entry.customObj) ? entry.customObj : {};
}

// Show the next question based on the user's input
function showNextQuestion(answer, element) {
  if (validateInputs(answer) == false) { return; }

  if (element) {
    element.classList.add('selected');

    var selectedAnswer = document.querySelector('.calc-button.selected');
    selectedAnswer.querySelector('.regular').style.display = "none";
    selectedAnswer.querySelector('.solid').style.display = "inline";
  }
  setTimeout(function() {

    $('.current-question').hide();

    setAnswer(answer);

    var currentQuestionObject = getQuestion(currentQuestionId);

    previousQuestionPath.push(currentQuestionObject.id);

    if (previousQuestionPath.length > 0) {
      $('.btn-previous').show();
    } else {
      $('.btn-previous').hide();
    }

    var nextQuestion;
    if (currentQuestionObject.minimumBasedDependency && currentQuestionObject.followUpQuestions[answer] != "END") {
      if (parseInt(getAnswer(currentQuestionObject.id)) >= currentQuestionObject.minimumBasedDependency.minimumCount) {
        if (currentQuestionObject.customAnswersBasedDependency) {
          var environmentType = getAnswer('environment');
          var edition = getAnswer('edition');
          if (edition == 'standard' && environmentType == 'on_prem') {
            nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremStandard;
          } else if (edition == 'standard' && environmentType == 'cloud') {
            nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudStandard;
          } else if (edition == 'enterprise' && environmentType == 'on_prem') {
            nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremEnterprise;
          } else if (edition == 'enterprise' && environmentType == 'cloud') {
            nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudEnterprise;
          }
        } else {
          nextQuestion = currentQuestionObject.minimumBasedDependency.minimumMet;
        }
      } else {
        nextQuestion = currentQuestionObject.minimumBasedDependency.minimumNotMet;
      }
    } else if (currentQuestionObject.customAnswersBasedDependency && currentQuestionObject.followUpQuestions[answer] != "END") {
      var environmentType = getAnswer('environment');
      var edition = getAnswer('edition');
      if (edition == 'standard') {
        nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremStandard;
      } else if (edition == 'enterprise' && environmentType == 'on_prem') {
        nextQuestion = currentQuestionObject.customAnswersBasedDependency.onPremEnterprise;
      } else if (edition == 'enterprise' && environmentType == 'cloud') {
        nextQuestion = currentQuestionObject.customAnswersBasedDependency.cloudEnterprise;
      }
    } else {
      nextQuestion = currentQuestionObject.followUpQuestions[answer];
    }

    currentQuestionId = nextQuestion;
    document.getElementById('sql-question-text').innerHTML = questionText(nextQuestion);
    setCalendlyOnClick('help', nextQuestion);

    var nextQuestionObject = getQuestion(nextQuestion);
    if (nextQuestionObject.id == 'END') {
      showResults();
    }

    displayAnswers(nextQuestionObject);

    $('.current-question').show();

    setTooltips();
  }, 100);
}

// Validate input value on-change
// (data-kind="cores" / "vms" replaces the old placeholder text checks; SQL inputs use neither)
function validateValue(value, e) {
  var isCores = e.dataset && e.dataset.kind == 'cores';
  var isVms = e.dataset && e.dataset.kind == 'vms';
  if (/^\d+$/.test(value)) {
    if (value.split('')[0] == '0') {
      e.value = 0;
      e.setAttribute("value", 0);
    }
    else if ((isCores || parseInt(e.min) > 0) && value == 0) {
      e.value = '';
      e.setAttribute("value", '');
      return;
    } else {
      e.setAttribute("value", value);
    }
    if (e.id == 'standard-input') {
      if (e.min && (e.dataset.eveninput == 'true')) {
        if (((BigInt(e.value) >= BigInt(e.min)) && (BigInt(e.value) % BigInt(2) == BigInt(0))) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)) {
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);
        } else {
          e.style.border = "2px solid red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (e.min) {
        if ((parseInt(e.value) >= parseInt(e.min)) || ((e.dataset.emptyinputaccepted == 'true') ? (parseInt(e.value) == 0 || parseInt(e.value) == '') : false)) {
          e.previousElementSibling.style.display = 'none';
          e.style.border = "2px solid var(--ttt-green)";
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          $('.collection-button').prop("disabled", false);
        } else {
          e.style.border = "2px solid red";
          $('.fa-circle-check').hide();
          $('.fa-circle-exclamation').show();
          $('.collection-button').prop("disabled", true);
        }
      } else if (value != '') {
        e.previousElementSibling.style.display = 'none';
        e.style.border = "2px solid var(--ttt-green)";
        $('.fa-circle-exclamation').hide();
        $('.fa-circle-check').show();
        $('.collection-button').prop("disabled", false);
      } else {
        e.style.border = "2px solid var(--main-text-color)";
        $('.fa-circle-check').hide();
        $('.fa-circle-exclamation').hide();
        $('.collection-button').prop("disabled", true);
      }
    } else {
      if (isCores && (parseInt(value) % 2 == 1 || parseInt(value) < 2 || e.value < 2)) {
        e.parentElement.style.border = "1px solid red";
        e.nextElementSibling.style.display = 'none';
        e.previousElementSibling.style.display = 'inline';
      } else {
        if (isCores || isVms) {
          e.parentElement.style.border = "1px solid var(--ttt-green)";
          e.previousElementSibling.style.display = 'none';
          e.nextElementSibling.style.display = 'inline';
        } else {
          e.previousElementSibling.style.display = 'none';
          $('.fa-circle-exclamation').hide();
          $('.fa-circle-check').show();
          e.parentElement.style.border = "1px solid var(--main-text-color)";
        }
      }
    }
  } else {
    if (e.id == 'standard-input' && value == '') {
      e.style.border = "2px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      $('.fa-circle-check').hide();
      $('.fa-circle-exclamation').hide();

      (parseInt(e.min) == 0) ? $('.collection-button').prop("disabled", false) : $('.collection-button').prop("disabled", true);
      return;
    }
    let inputString = convertToNumeric(value);
    e.value = inputString;
    e.setAttribute("value", inputString);
    if (isCores || isVms) {
      e.parentElement.style.border = "1px solid var(--main-text-color)";
      e.style.color = "var(--main-text-color)";
      e.previousElementSibling.style.display = 'none';
      e.nextElementSibling.style.display = 'none';
    }
    return;
  }
}

// Remove any non-numerical values from string
function convertToNumeric(str) {
  return str.replace(/[^0-9]/g, '');
}

// Display loading screen for 3 seconds
function displayLoadingIcon() {
  $('#loading-screen').show();
  setTimeout(() => {
    $('#loading-screen').hide();
  }, 3000);
}

// Builds the list of answered questions. lang: 'display' (translated) or 'en' (sales-facing)
function getAnsweredItems(lang) {
  var items = [];
  var q = lang == 'en' ? questionTextEn : questionText;
  var a = lang == 'en' ? answerLabelEn : answerLabel;
  var t = lang == 'en' ? en : tr;
  userAnswers.forEach((entry) => {
    if (entry.answerType == 'over_max') {
      items.push({ question: q(entry.id), answer: t('ui.more_than', { n: entry.overMax }) });
    } else if (entry.answer) {
      items.push({ question: q(entry.id), answer: entry.answerType == 'option' ? a(entry.answer) : entry.answer });
    }
    if (entry.customObj) {
      var countKey = entry.customObj.type == 'device' ? 'ui.devices_count' : 'ui.users_count';
      items.push({ question: q(entry.id), answer: t(countKey, { n: entry.customObj.total }) });
    }
  });
  return items;
}

// Set question and answers to be displayed on the results page
function setResponses() {
  var visibleAnswers = '';
  getAnsweredItems('display').forEach((item) => {
    visibleAnswers += '<p style="margin-bottom: 0; color: var(--main-text-color);">' + item.question + '</p>';
    visibleAnswers += '<p style="color: var(--ttt-green);">' + item.answer + '</p>';
  });
  document.getElementById("sql-responses").innerHTML = visibleAnswers;
}

// Builds a license name. lang: 'display' or 'en'
function licenseName(lang, type, vars) {
  var t = lang == 'en' ? en : tr;
  var v = Object.assign({}, vars);
  v.sa = vars.sa ? t('licenses.sa_suffix') : '';
  return t('licenses.' + type, v);
}

// Edition names are Microsoft product names and stay in English
function editionName(id) {
  return en('answers.' + id);
}

// Returns the core count from the host or VM question
function getCoreCount() {
  return getAnswer('deployment') == 'host' ? getAnswer('host_cores') : getAnswer('vm_cores');
}

// Calculate licensing info to be displayed on the results page
function calculateLicensing() {
  var environment = getAnswer('environment');
  var year = getAnswer('version');
  var edition = getAnswer('edition');
  var runsPublicApp = getAnswer('public_app') == 'yes';

  var numberOfConnections = 0;
  var numCores = 0;

  var serverTableResults = '';
  var coreTableResults = '';
  var calLicensingRow = '';
  var licenseArray = [];

  var recommendedModel;

  // Server+CAL and Core licensing rules shared by On-Premises and Cloud Standard
  function meetsBothThreshold() {
    return (
      (numberOfConnections >= 25 && numberOfConnections <= 37 && numCores <= 6) ||
      (numberOfConnections >= 38 && numberOfConnections <= 50 && numCores <= 8) ||
      (numberOfConnections >= 51 && numberOfConnections <= 63 && numCores <= 10) ||
      (numberOfConnections >= 64 && numberOfConnections <= 76 && numCores <= 12) ||
      (numberOfConnections >= 77 && numberOfConnections <= 89 && numCores <= 14) ||
      (numberOfConnections >= 90 && numberOfConnections <= 102 && numCores <= 16) ||
      (numberOfConnections >= 103 && numberOfConnections <= 115 && numCores <= 18) ||
      (numberOfConnections >= 116 && numberOfConnections <= 128 && numCores <= 20) ||
      (numberOfConnections >= 129 && numberOfConnections <= 141 && numCores <= 22) ||
      (numberOfConnections >= 142)
    );
  }

  // Connections and cores for Standard edition (On-Premises or Cloud)
  function readStandardInputs() {
    if (getAnswer('query_method') == 'direct') {
      numberOfConnections = parseInt(getConnections('connections_direct').total);
      if (numberOfConnections >= 25) {
        numCores = getCoreCount();
      }
    } else { // Through an application
      if (!runsPublicApp) {
        numberOfConnections = parseInt(getConnections('connections_app').total);
        if (numberOfConnections >= 25) {
          numCores = getCoreCount();
        }
      } else {
        numCores = getCoreCount();
      }
    }
  }

  function addLicense(type, vars, total) {
    licenseArray.push({
      type: type,
      name: licenseName('display', type == 'serverPlusCAL' ? 'server' : 'core', vars),
      nameEn: licenseName('en', type == 'serverPlusCAL' ? 'server' : 'core', vars),
      total: total
    });
    return licenseArray[licenseArray.length - 1];
  }

  if (edition == 'standard') {
    var sa = environment == 'cloud';
    readStandardInputs();
    var coreEdition = editionName(numCores > 24 ? 'enterprise' : 'standard');

    if (meetsBothThreshold()) {
      var calLicense = addLicense('serverPlusCAL', { year: year, edition: editionName(edition), sa: sa }, "1");
      var coreLicense = addLicense('core', { year: year, edition: coreEdition, sa: sa }, numCores / 2);
      recommendedModel = 'both';
      appendToFormData(rfqModelHeader(en, 'both') + en('rfq.server_cal_licensing') + '\r\n', rfqModelHeader(tr, 'both') + tr('rfq.server_cal_licensing') + '\r\n');
      appendToFormData('1 x ' + calLicense.nameEn + '\r\n', '1 x ' + calLicense.name + '\r\n');
      calLicensingRow = getCalLicensingTableRow();
      appendToFormData('\r\n' + en('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.nameEn + '\r\n', '\r\n' + tr('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.name + '\r\n');
    } else if (runsPublicApp) {
      var coreLicense = addLicense('core', { year: year, edition: coreEdition, sa: sa }, numCores / 2);
      recommendedModel = 'core';
      appendToFormData(rfqModelHeader(en, 'core_model'), rfqModelHeader(tr, 'core_model'));
      appendToFormData(en('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.nameEn + '\r\n', tr('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.name + '\r\n');
    } else {
      var calLicense = addLicense('serverPlusCAL', { year: year, edition: editionName(edition), sa: sa }, "1");
      recommendedModel = 'server_cal';
      appendToFormData(rfqModelHeader(en, 'server_cal_model') + en('rfq.server_cal_licensing') + '\r\n', rfqModelHeader(tr, 'server_cal_model') + tr('rfq.server_cal_licensing') + '\r\n');
      appendToFormData('1 x ' + calLicense.nameEn + '\r\n', '1 x ' + calLicense.name + '\r\n');
      calLicensingRow = getCalLicensingTableRow();
    }
  } else if (edition == 'enterprise') {
    var sa = environment == 'cloud';
    numCores = environment == 'cloud' ? getAnswer('vm_cores') : getCoreCount();
    var coreLicense = addLicense('core', { year: year, edition: editionName(edition), sa: sa }, numCores / 2);
    recommendedModel = 'core';
    appendToFormData(rfqModelHeader(en, 'core_model'), rfqModelHeader(tr, 'core_model'));
    appendToFormData(en('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.nameEn + '\r\n', tr('rfq.core_licensing') + '\r\n' + numCores / 2 + ' x ' + coreLicense.name + '\r\n');
  }

  licenseArray.forEach((license) => {
    var row = '<tr class="results-table-row"><td class="text-start">' + license.name + '</td><td class="text-center">' + license.total + '</td></tr>';
    if (license.type == "serverPlusCAL") {
      serverTableResults += row;
    } else if (license.type == "core") {
      coreTableResults += row;
    }
  });

  var calCount = getCalCount();
  var scheduleLink = "<a class='highlight-link' href onclick='scheduleSqlCalc()'>" + tr('results.scheduling_a_call') + "</a>";

  if (recommendedModel == 'server_cal' || recommendedModel == 'core') {
    var modelHTML = "<strong class='highlight-text'>" + tr('results.model_' + recommendedModel) + "</strong>";
    var licensingModelBodyText = tr('results.recommend_html', { model: modelHTML });
    var whatYouNeedBodyText = tr('results.what_you_need_model', { model: modelHTML });
    if (runsPublicApp && edition == 'standard' && numCores > 24) {
      whatYouNeedBodyText += tr('results.enterprise_required');
    }
    var recommendedTag = '<span class="position-absolute" style="box-shadow: 0px 2px 5px 0px var(--box-shadow); padding: 5px 10px; font-size: var(--font-size-xxs); border-radius: 3px; background: gold; color: black; top: -20px; left: 50%; transform: translateX(-50%); width: max-content;"><i class="fa-solid fa-thumbs-up me-2"></i> ' + tr('results.our_recommendation') + '</span>';
    document.querySelector('#licensing-models-body').innerHTML = licensingModelBodyText;
    if (recommendedModel == 'server_cal') {
      document.querySelector("#server-cal-box").classList.remove("standard-box");
      document.querySelector("#server-cal-box").classList.add("recommended-box", "recommended-option");
      document.querySelector("#server-cal-box").insertAdjacentHTML('afterbegin', recommendedTag);
      document.querySelector("#serverPlusCalTableResults").classList.add("recommended-option");
      document.querySelector("#serverPlusCalTableResults").style.display = "block";
      calCount > 4 && (document.querySelector('#cal-recommend-bundle').style.display = 'flex');
    } else if (recommendedModel == 'core') {
      document.querySelector("#core-box").classList.remove("standard-box");
      document.querySelector("#core-box").classList.add("recommended-box", "recommended-option", "mt-5", "mt-xxl-0");
      document.querySelector("#core-box").insertAdjacentHTML('afterbegin', recommendedTag);
      document.querySelector("#coreTableResults").classList.add("recommended-option");
      document.querySelector("#coreTableResults").style.display = "block";
    }
    document.querySelector("#what-you-need-body").innerHTML = whatYouNeedBodyText;
  } else if (recommendedModel == 'both') {
    document.querySelector('#licensing-models-body').innerHTML = tr('results.both_models', { link: scheduleLink });
    if (edition == 'standard' && numberOfConnections >= 142 && numCores > 24) {
      $("#core-model-disclaimer").show();
    }
    document.querySelector("#what-you-need-body").innerHTML = tr('results.both_what_you_need', { link: scheduleLink });
    document.querySelector("#serverPlusCalTableResults").style.display = "block";
    document.querySelector("#coreTableResults").style.display = "block";
    calCount > 4 && (document.querySelector('#cal-recommend-bundle').style.display = 'flex');
  }
  document.querySelector('#sql-table-header').innerHTML = '<th style="text-align: left; width: 75%;">' + tr('results.th_recommended_license') + '</th><th class="text-center">' + tr('results.th_num_licenses') + '</th>';
  document.querySelector("#sql-table-results").innerHTML = serverTableResults + calLicensingRow;
  document.querySelector("#core-table-results").innerHTML = coreTableResults;

  if (year === "2025") {
    $("#core-model-disclaimer").show();
    document.querySelector('#core-model-disclaimer p').innerHTML = "<i class='fa-solid fa-flag'></i> " + tr('results.core_disclaimer_2025');
  } else {
    document.querySelector('#core-model-disclaimer p').innerHTML = "<i class='fa-solid fa-flag'></i> " + tr('results.core_disclaimer');
  }
}

// Set CAL licensing info to be displayed on the results page
function getCalLicensingTableRow() {
  var calLicensingTableHTML = '';
  var calYear = getAnswer('version');
  var sa = getAnswer('environment') == 'cloud';
  var cal = null;

  if (getAnswer('query_method') == 'direct') {
    cal = getConnections('connections_direct');
  } else if (getAnswer('query_method') == 'application' && getAnswer('public_app') == 'no') {
    cal = getConnections('connections_app');
  }

  if (cal) {
    var typeKey = cal.type == 'device' ? 'licenses.cal_type_device' : 'licenses.cal_type_user';
    var calCount = cal.total;
    var displayName = tr('licenses.cal', { year: calYear, type: tr(typeKey), sa: sa ? tr('licenses.sa_suffix') : '' });
    var englishName = en('licenses.cal', { year: calYear, type: en(typeKey), sa: sa ? en('licenses.sa_suffix') : '' });
    calLicensingTableHTML += '<tr><td class="color-highlight">' + displayName + '</td><td class="text-center">' + calCount + '</td></tr>';
    appendToFormData(calCount + ' x ' + englishName + '\r\n', calCount + ' x ' + displayName + '\r\n');
  }
  return calLicensingTableHTML;
}

// Returns the amount of connections required based on the user's responses
function getCalCount() {
  if (getAnswer('query_method') == 'direct') {
    return getConnections('connections_direct').total || 0;
  } else if (getAnswer('query_method') == 'application') {
    return getConnections('connections_app').total || 0;
  }
  return 0;
}

// Sets the user's answers to be sent if 'Request a Quote' form submitted (English)
function addResponsesToRFQ() {
  calcResults += '\r\n' + en('rfq.responses') + '\r\n';
  getAnsweredItems('en').forEach((item) => {
    calcResults += item.question + '\r\n';
    calcResults += item.answer + '\r\n\r\n';
  });
  calcResultsLocal += '\r\n' + tr('rfq.responses') + '\r\n';
  getAnsweredItems('display').forEach((item) => {
    calcResultsLocal += item.question + '\r\n';
    calcResultsLocal += item.answer + '\r\n\r\n';
  });
}

// "Recommended licensing model:" block for the quote form text
function rfqModelHeader(t, model) {
  return t('rfq.recommended_model') + '\r\n' + t('rfq.' + model) + '\r\n\r\n';
}

// Text passed to the quote form: English only on the English storefront,
// otherwise the visitor's language first, then the English copy for sales
function rfqForForm() {
  if (!window.SQL_CALC_BILINGUAL) { return calcResults; }
  return calcResultsLocal;
}

// Generate link to pre-filled Calendly form based on data from calculator (English), pass in response and question ID if generating link while user is on a question
function setPrefilledCalendlyFormLink(response, questionId) {
  calendlySqlLink = CALENDLY_SQL_BASE;
  var calendlyParams = '';

  // Prefill with current question if help requested
  if (response == 'help') {
    calendlyParams += "Hi TrustedTech,%0A%0AI need help answering this question on the SQL Server Calculator:%0A" + questionTextEn(questionId) + "%0A%0A";
  } else if (response == "calc-error") {
    calendlyParams += "Hi TrustedTech,%0A%0AI need SQL Server, but I have a complex environment. Can you please evaluate it?%0A%0A";
  }

  if (currentQuestionId != 'environment') {
    calendlyParams += 'Here are my SQL Server calculator responses:%0A%0A';
    getAnsweredItems('en').forEach((item) => {
      calendlyParams += 'Q: ' + item.question + '%0A';
      calendlyParams += 'A: ' + item.answer + '%0A%0A';
    });
  }

  calendlySqlLink += '?a2=' + calendlyParams;
}

// Triggered when user reaches the last question in a pathway
function showResults(action) {
  $("#sql-questions").addClass("hidden");
  window.scroll(0, 0);

  displayLoadingIcon();

  setTimeout(() => {
    $('#loading-screen').hide();
    if (action == "calc-error") {
      setCalendlyOnClick("calc-error");
      $("#sql-no-results").removeClass("hidden");
    } else if (getAnswer('instances') == 'one') {
      $("#sql-results").removeClass("hidden");
    } else {
      setCalendlyOnClick("calc-error");
      $("#sql-no-results").removeClass("hidden");
    }
  }, 1000);

  setResponses();
  try {
    calculateLicensing();
  } catch (err) {
    console.error('SQL calculator: could not calculate licensing', err);
  }
  addResponsesToRFQ();

  // AE (Account Engagement) Express Quote landing page. Results are passed via 'wsc_results'.
  // pageHandle variable pulled from sql-server-calculator.liquid
  // SQL_CALC_QUOTE_FORM_URL is set per language in the section (German form on /de once it exists)
  var quoteFormUrl = window.SQL_CALC_QUOTE_FORM_URL || 'https://marketing.trustedtechteam.com/l/1073191/2026-07-13/44lw3b5';
  // The AE landing page rejects very long links, so if the bilingual text would make the link
  // longer than 7,000 characters, send the English text only (same as the English storefront)
  var rfqText = rfqForForm();
  var rfqSrc = quoteFormUrl + '?wsc_results=' + encodeURIComponent(rfqText) + '&wsc_page=' + pageHandle;
  if (rfqSrc.length > 7000 && rfqText !== calcResults) {
    rfqSrc = quoteFormUrl + '?wsc_results=' + encodeURIComponent(calcResults) + '&wsc_page=' + pageHandle;
  }
  $('#request-a-quote-form').html('<iframe frameborder="0" id="rfq-iframe" style="height:697px;width:99%;border:none;color-scheme:light;" src="' + rfqSrc + '"></iframe>');

  setPrefilledCalendlyFormLink();
}

// Adds to the 'Request a Quote' form data (English, and the visitor's language when given)
function appendToFormData(data, localData) {
  calcResults += data;
  calcResultsLocal += (localData === undefined ? data : localData);
}

// Shows the first question in the calculator. Triggered when user clicks 'Start' on landing page.
function beginCalculator() {
  $("#main-questions-container").addClass("hidden");
  $("#sql-questions").removeClass("hidden");
  window.scroll(0, 0);
}

// Resets content and goes back to 1st question. Triggered when user clicks any 'Restart Calculator' button
function restartSqlCalc() {

  // Reset global variables
  previousQuestionPath = [];
  calendlySqlLink = CALENDLY_SQL_BASE;
  calcResults = CALC_RESULTS_INTRO;
  calcResultsLocal = rfqIntro(tr);

  // Reset all answers
  userAnswers.forEach(function(entry) { clearAnswer(entry); });

  // Hide results page, restore results page content, show first question
  $('#sql-results').addClass("hidden");
  document.getElementById('licensing-models-container').innerHTML = initialResultsHTML.models;
  document.getElementById('cal-licensing-container').innerHTML = initialResultsHTML.cal;
  renderQuestion('environment');
  $('.btn-previous').hide();
  $("#sql-no-results").addClass("hidden");
  $("#sql-questions").removeClass("hidden");
  window.scroll(0, 0);
}

// Initialize the tooltips if applicable
function setTooltips() {
  $(function() {
    tippy('[data-tippy-content]');
  });
}

// Sets the onclick function for any Calendly button on a question to include the current question and all previous answers
function setCalendlyOnClick(response, questionId) {
  var calendlyButton;
  if (response == 'help') {
    setPrefilledCalendlyFormLink(response, questionId);
    calendlyButton = document.getElementById('calendly-button-container').querySelector('.button-calendly');
  } else if (response == "calc-error") {
    setPrefilledCalendlyFormLink(response);
    calendlyButton = document.getElementById('sql-no-results').querySelector('.button-calendly');
  }

  calendlyButton.setAttribute('onclick', 'scheduleSqlCalc()');

  var calendlyFixedButton = document.querySelector('.btn-fixed-calendly');
  if (calendlyFixedButton) {
    calendlyFixedButton.setAttribute('onclick', 'scheduleSqlCalc()');
  }
}

// Display Calendly pop-up form
function scheduleSqlCalc() {
  Calendly.showPopupWidget(calendlySqlLink);
  return false;
}

// Render the first question on load
renderQuestion('environment');
